import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getParams } from '../common/common.func';
import { PagedList } from '../common/common.types';
import { MetaStatus } from '../meta/meta.types';
import {
  NewProduct,
  Product,
  ProductFilter,
  UpdatedProduct,
  ProductV2,
} from './product.types';

@Injectable()
export class ProductService {
  private productsUrl = 'api/products';
  private productSearchAPIURL = 'product-search-api';

  constructor(private _http: HttpClient) {}

  getProducts(filter?: ProductFilter): Promise<PagedList<Product>> {
    const options = { params: getParams(filter) };
    return this._http
      .get<PagedList<Product>>(this.productsUrl, options)
      .toPromise();
  }

  getProductsV2(filter?: ProductFilter): Promise<PagedList<ProductV2>> {
    const url = `${this.productSearchAPIURL}/api/v1/products/search-collection?projections=location&projections=eventLocation`;
    return this._http.get<PagedList<ProductV2>>(url).toPromise();
  }

  createProduct(newProduct: NewProduct): Promise<number> {
    return this._http.post<number>(this.productsUrl, newProduct).toPromise();
  }

  updateProduct(
    productId: number,
    updatedProduct: UpdatedProduct
  ): Promise<void> {
    return this._http
      .put<void>(`${this.productsUrl}/${productId}`, updatedProduct)
      .toPromise();
  }

  updateProductStatus(productId: number, status: MetaStatus): Promise<void> {
    return this._http
      .put<void>(`${this.productsUrl}/${productId}/status/${status}`, null)
      .toPromise();
  }

  archiveProduct(productId: number): Promise<void> {
    return this._http
      .delete<void>(`${this.productsUrl}/${productId}`)
      .toPromise();
  }
  
    getProductById(
      productId: string
    ): Promise<any> {
      const url = `${this.productSearchAPIURL}/api/v1/products?id=${productId}`;
      return this._http.get<any>(url).toPromise()
    }
}
